import React, { useState, useMemo, useCallback, useEffect } from "react";
import { ReactComponent as GreenEye } from "../../../assets/svgs/greenEye.svg";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../components/Elements/Tables/Tables";
import CardsBorder from "../../../components/Cards/CardsBorder";
import { getApi, putApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import CustomSwitch from "../../../components/Elements/CustomSwitch/CustomSwitch";
import CustomerAddUser from "./Roles/DIalogBoxes/CustomerAddUser";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";
import { useNavigate, useLocation } from "react-router-dom";
import {ReactComponent as FilterIcon} from "../../../assets/svgs/filter-icon.svg"
import UserFilter from "./Roles/DIalogBoxes/UserFilter";
import { Button } from "antd";
const UserTable = ({ clientId, setOpenUserDetailsPage, setEachUserId, projectId, noPadding }) => {
  const location = useLocation();
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [tableData, setTablecData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openAddUser, setOpenAddUser] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isSuccess, setIsSuccess] = useState(true);
  const [statusMessage, setStatusMessage] = useState("");
  const [popupData, setPopupData] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [filterData, setFilterData] = useState({ status: "", role: "" });
  // const [userToggles, setUserToggles] = useState(false);
  const [popup, setPopup] = useState({
    visible: false,
    type: "success",
    title: "",
    message: "",
  });
  const pageSize = 5;
  const [sortOrder, setSortOrder] = useState("-createdAt");
  const [loadingUsers, setLoadingUsers] = useState(false);
const [searchTerm, setSearchTerm] = useState("");
  // const location = useLocation();
const navigate = useNavigate();
  const isNoUsersFound = (value) => {
    const message =
      typeof value === "string"
        ? value
        : value?.message || value?.response?.data?.message || "";
    const normalizedMessage = String(message).toLowerCase();

    return (
      normalizedMessage.includes("no user") ||
      normalizedMessage.includes("no users") ||
      normalizedMessage.includes("user not found") ||
      normalizedMessage.includes("users not found") ||
      normalizedMessage.includes("status code 404")
    );
  };


  
  const fetchUserData = async (clientId) => {
    if (!clientId) return;
    try {
      setLoadingUsers(true);
      const response = await getApi({
        apiUrl: API_URLS.GET_ALL_CUSTOMER_USER(
          currentPage,
          pageSize,
          sortOrder,
          clientId,
          debouncedSearch,
          filterData
        ),
        headers: { client: clientId },
      });

      if (response?.success === false && isNoUsersFound(response)) {
        setTotalRecords(0);
        setTablecData([]);
        return;
      }

      // adapt depending on shape: earlier version used response.total and response.data
      setTotalRecords(response.total || 0);

      const usersList = Array.isArray(response.data)
        ? response.data
        : response.data?.users || [];

      const allUsers = usersList.map((user, index) => ({
        key: user._id,
        serial: (currentPage - 1) * pageSize + index + 1,
        name: <div className="text-center">{user.name}</div>,
        userId: user.employee_id,
        userName: <div className="text-center">{user.email}</div>,
        role: <div className="text-center">{Array.isArray(user.role) ? user.role.join(", ") : user.role}</div>,
        
        action: (
          <div className="flex gap-4 items-center justify-center">
            <GreenEye
              onClick={() => {
                const isProjectPage = location.pathname.includes('/projects/project-page');
                const targetPath = isProjectPage ? '/projects/project-page/user-details' : '/setting/users/user-details';
                  const navState = {
                    emp_id: user.employee_id,
                    emp_name: user.name,
                    userId: user._id,
                    clientId,
                    ...(isProjectPage && { projectId, projectPage: true }),
                  };
                navigate(targetPath, { state: navState });
              }}
            />
            <CustomSwitch
              checked={user.status === "Active"}
              onChange={() => handleToggleStatus(user._id, user.status)}
            />
          </div>
        ),
      }));
      setTablecData(allUsers);
    } catch (error) {
      if (isNoUsersFound(error)) {
        setTotalRecords(0);
        setTablecData([]);
        return;
      }

      console.error("Error fetching user data:", error);
      setPopupData({
        type: "error",
        title: "Fetch Failed",
        message:
          error?.response?.data?.message ||
          error.message ||
          "Unable to load user data.",
      });
    } finally {
      setLoadingUsers(false);
    }
  };

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Name", key: "name" },
      { label: "User Id", key: "userId" },
      { label: "User Name", key: "userName" },
      { label: "Role", key: "role" },
      { label: "Action", key: "action" },
    ],
    []
  );

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
    sessionStorage.setItem("customerUserTablePage", page.toString());
  }, []);

  useEffect(() => {
    const savedPage = sessionStorage.getItem("customerUserTablePage");
    if (savedPage) {
      setCurrentPage(parseInt(savedPage, 10));
    }
  }, []);

  const handleSort = useCallback(() => {
    setSortOrder((prevOrder) =>
      prevOrder === "createdAt" ? "-createdAt" : "createdAt"
    );
  }, []);

  useEffect(() => {
    if (clientId) {
      fetchUserData(clientId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, currentPage, sortOrder, debouncedSearch, filterData]);

  // Debounce search input
  useEffect(() => {
    const delay = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // wait 0.5s after typing stops
    return () => clearTimeout(delay);
  }, [searchTerm]);

  useEffect(() => {
    if (!popupData) return;

    const timer = setTimeout(() => {
      setPopupData(null);
    }, 2000);

    return () => clearTimeout(timer);
  }, [popupData]);

  const closePopup = () => {
    setPopup((p) => ({ ...p, visible: false }));
  };

  const handleToggleStatus = async (userId, currentStatus) => {
    try {
      const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

      const response = await putApi({
        apiUrl: API_URLS.UPDATE_CUSTOMER_USER(userId),
        data: { status: newStatus },
        headers: { client: clientId },
      });
      if (response.success) {
        setStatusMessage(
          `User Management ${newStatus === "Active" ? "Active" : "Inactive"
          } is successfully.`
        );
        setPopupData({
          type: "success",
          title: "Success!!",
          message: "Status changes successfully",
        });
        setIsSuccess(newStatus === "Active");
        fetchUserData(clientId);
      } else {
        setPopupData({
          type: "warning",
          title: "Failed in Updating Status",
          message: `${response.message}`,
        });
      }
    } catch (error) {
      console.error("Error updating user status:", error);
      setPopupData({
        type: "error",
        title: "Failed !!",
        message: `${error.message}`,
      });
    }
  };

  return (
    <div style={{paddingLeft: noPadding ? "0" : "40px", paddingRight: noPadding ? "0" : "40px", paddingTop: "20px"  }}>
      <CardsBorder>
        <div className="flex justify-between ">
          <div className="flex justify-between my-4 font-medium">
            <div className="flex gap-8">
              <p className="text-[#06513D] pt-2 px-10 text-xl">User Details</p>
              <SearchBar
                width="300px"
                onSearch={(value) => setSearchTerm(value)}
              />
            </div>
          </div>
          <div className="flex px-10 gap-2">
            
             <Button
                onClick={() => setOpenFilter(true)}
                style={{ background: "#E6EDEB", border: "solid 1px #06513D" }}
                className="text-[12px] text-[#06513D] font-light px-4 h-[50px] py-5 hover:!bg-[#F8F8F8]  hover:!text-[#06513D]"
              >
                <FilterIcon /> FILTER
              </Button>
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Export"
              className="text-sm h-[50px]"
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Import"
              className="text-sm h-[50px]"
              onClick={() => navigate(`/customer/customer-page/${clientId}/import-users`)}
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="+ ADD USERS"
              className="text-sm h-[50px]"
              onClick={() => setOpenAddUser(true)}
            />
          </div>
        </div>
        <Tables
          data={tableData}
          headers={headers}
          pageSize={pageSize}
          total={totalRecords}
          current={currentPage}
          onChange={handlePageChange}
          onSort={handleSort}
          loading={loadingUsers}
        />
      </CardsBorder>

      {openAddUser && (
        <CustomerAddUser
          onOpen={openAddUser}
          onClose={() => setOpenAddUser(false)}
          clientId={clientId}
          onSave={() => {
            setOpenAddUser(false);
            setPopupData({
              type: "success",
              title: "User Created",
              message: "User data saved successfully.",
            });
            fetchUserData(clientId);
          }}
        />
      )}

      {popupData && (
        <div className="fixed inset-0 bg-black/30 z-[2000] flex items-center justify-center">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}

      
      {openFilter && (
        <UserFilter
          onOpen={openFilter}
          onClose={() => setOpenFilter(false)}
          setFilterData={setFilterData}
          initialFilter={filterData}
        />
      )}
    </div>
  );
};

export default UserTable;
